import { LOGGER_SHOW_LOGS_LOCAL_STORE_KEY } from 'components/Logger/Logger.values';
import pjson from '../../package.json';
import { IAPI_URL, IAPP_INFO, ICHAT_API_URL, ILEANPLUM_CONFIG, ILINK_INSTALL_APPS } from './@types';

const ENV = process.env.REACT_APP_ENVIRONMENT || 'development';

const IS_PROD = ENV === 'production';

const PAYWALL_DOMAIN = (process.env.REACT_APP_PAYWALL_DOMAIN || '').toLowerCase();
const PP_DOMAIN = (process.env.REACT_APP_PP_DOMAIN || '').toLowerCase();

const SHOW_LOGS = window.localStorage.getItem(LOGGER_SHOW_LOGS_LOCAL_STORE_KEY) === 'true';

const APP_INFO: IAPP_INFO = {
  isProd: IS_PROD,
  showLogs: SHOW_LOGS,
  Env: ENV,
  name: pjson.name,
  version: pjson.version,
  description: 'kinedu onboarding',
  versionComplete: `v${pjson.version}`,
  buildName: 'META',
  buildDescription: 'META',
  isPaywallDomain: window.location.host.toLowerCase().search(PAYWALL_DOMAIN) !== -1,
  isPPDomain: window.location.host.toLowerCase().search(PP_DOMAIN) !== -1,
  date: '29-01-2025',
};

const API_URL: IAPI_URL = {
  base: process.env.REACT_APP_API_BASE || '',
  name: process.env.REACT_APP_API_NAME || '',
  timeout: Number(String(process.env.REACT_APP_API_BASE_TIMEOUT)) || 60000,
  versions: {
    V3: 'v3',
    V4: 'v4',
    V5: 'v5',
  },
};

const CHAT_API_URL: ICHAT_API_URL = {
  base: process.env.REACT_APP_CHAT_API_BASE || '',
  name: process.env.REACT_APP_CHAT_API_NAME || '',
  timeout: Number(String(process.env.REACT_APP_CHAT_API_BASE_TIMEOUT)) || 60000,
  versions: {
    V1: 'v1',
    V2: 'v2',
  },
  token: process.env.REACT_APP_CHAT_API_TOKEN || '',
};

const EVENTS_CONFIG = {
  META_PIXEL: {
    PIXEL_ID: process.env.REACT_APP_META_PIXEL_ID || '',
  },
  MIXPANEL: {
    KEY: process.env.REACT_APP_MIXPANEL_API_KEY || '',
  },
};

const LEANPLUM_CONFIG: ILEANPLUM_CONFIG = {
  APP_ID: `${process.env.REACT_APP_LEANPLUM_APP_ID}`,
  KEY: `${process.env.REACT_APP_LEANPLUM_KEY}`,
  DEFAULT_DATA: {
    PAYWALL: {
      webSku: process.env.REACT_APP_LEANPLUM_PAYWALL_WEB_SKU || '',
      webColor: process.env.REACT_APP_LEANPLUM_PAYWALL_WEB_COLOR || '',
    },
    PAYWALL_NBY: {
      webSku: process.env.REACT_APP_LEANPLUM_PAYWALL_WEB_NBY_SKU || '',
      webColor: process.env.REACT_APP_LEANPLUM_PAYWALL_NBY_WEB_COLOR || '',
    },
    PP: {
      webSkuPremiumFirst: process.env.REACT_APP_LEANPLUM_PP_WEB_SKU_PREMIUM_FIRST || '',
      webSkuPremiumSecond: process.env.REACT_APP_LEANPLUM_PP_WEB_SKU_PREMIUM_SECOND || '',
      webSkuPremiumThird: process.env.REACT_APP_LEANPLUM_PP_WEB_SKU_PREMIUM_THIRD || '',
      webMonthlyPricePremiumFirst: process.env.REACT_APP_LEANPLUM_PP_WEB_MONTHLY_PRICE_PREMIUM_FIRST || '',
      webMonthlyPricePremiumThird: process.env.REACT_APP_LEANPLUM_PP_WEB_MONTHLY_PRICE_PREMIUM_SECOND || '',
      webMonthlyPricePremiumSecond: process.env.REACT_APP_LEANPLUM_PP_WEB_MONTHLY_PRICE_PREMIUM_THIRD || '',
      webColor: '#3EB646',
    },
  },
};

const LINK_INSTALL_APPS: ILINK_INSTALL_APPS = {
  APPSTORE: {
    ID: process.env.REACT_APP_APPSTORE_ID || '',
    BROWSER: `https://apps.apple.com/us/app/kinedu-baby-development-plan/${process.env.REACT_APP_APPSTORE_ID}`,
    MOBILE: `https://apps.apple.com/us/app/kinedu-baby-development-app/${process.env.REACT_APP_APPSTORE_ID}`,
  },
  PLAYSTORE: {
    ID: process.env.REACT_APP_PLAYSTORE_ID || '',
    BROWSER: `https://play.google.com/store/apps/details?id=${process.env.REACT_APP_PLAYSTORE_ID}&hl=es_419`,
    MOBILE: `market://details?id=${process.env.REACT_APP_PLAYSTORE_ID}`,
  },
};

const STRIPE = {
  PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY || '',
  PUBLIC_KEY_BRAZIL: process.env.REACT_APP_STRIPE_BRAZIL_PUBLIC_KEY || '',
};

const PAYPAL = {
  CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
};

const SENTRY_DNS: string = process.env.REACT_APP_SENTRY_DNS || '';

const FORMSTACK_QUIZ = {
  FORMS_URLS: {
    en: process.env.REACT_APP_FORMSTACK_QUIZ_URL_EN || '',
    es: process.env.REACT_APP_FORMSTACK_QUIZ_URL_ES || '',
    pt: process.env.REACT_APP_FORMSTACK_QUIZ_URL_PT || '',
  },
};

const EXTERNAL_ROUTES = {
  KWA: process.env.REACT_APP_KWA_URL || '',
};

window.Kinedu = {
  ...APP_INFO,
};

export {
  APP_INFO,
  API_URL,
  CHAT_API_URL,
  ENV,
  IS_PROD,
  EVENTS_CONFIG,
  SHOW_LOGS,
  LEANPLUM_CONFIG,
  LINK_INSTALL_APPS,
  STRIPE,
  SENTRY_DNS,
  PAYPAL,
  FORMSTACK_QUIZ,
  EXTERNAL_ROUTES,
};
